import { createSlotAndPlug } from "react-view-slot"


export const [ HeaderSlot, HeaderPlug ] = createSlotAndPlug("header")

export const [ HeaderTitleSlot, HeaderTitlePlug ] = createSlotAndPlug("header_title")

export const [ HeaderControlsSlot, HeaderControlsPlug ] = createSlotAndPlug("header_controls")
